(function () {
  'use strict';

  angular.module('app.referral-analytics.teacher-comparisons', []);

})();
